module.exports = __webpack_public_path__ + "static/media/helping.d8aea969.jpg";